import { RichTextRenderer } from "components/Contentful/RichTextRenderer"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import React from "react"
import type { TextOnlyProps } from "types/cms"
import { isDocument } from "utils/isDocumentTypeGuard"
import { RichTextFlat } from "../RichTextFlat"

import { containerColors } from "./TextOnly.css"

type Props = TextOnlyProps & CMSPageProps

export const TextOnly: React.FC<Props> = ({ content, backgroundColor }) => {
  return (
    <div className={containerColors[backgroundColor.toLowerCase()]}>
      {content && isDocument(content) && <RichTextRenderer content={content} />}
      {content && typeof content === "string" && (
        <RichTextFlat content={content as string} />
      )}
    </div>
  )
}
